module.exports = __webpack_public_path__ + "img/order-book.49ef1f8f.svg";